module.exports = __webpack_public_path__ + "img/108.d6c1ce97.jpg";